<script type="text/javascript">
	import { createEventDispatcher } from "svelte"
	import { get } from "svelte/store"
	import LoadState from "../../Enums/LoadState";
	import MapStore from "../../Map/Store";

	export let marmans = [];
	export let filterString = "";
	export let height = 300;

	let style = "height:"+height+"px;min-height:"+height+"px;";

	const dispatch = createEventDispatcher(); // update
</script>

<div class="marmans-table-container mdc-elevation--z2" style={style}>
	<table class='svelte-table'>
		<thead>
			<tr>
				<th>Name</th>
				<th width="120">Category</th>
				<th width="60">Visible</th>
			</tr>
		</thead>
		<tbody>
			{#each marmans as marman (marman.uniqId)}
				{#if (filterString.trim().length === 0 ||
					marman.name.toLowerCase().indexOf(filterString.toLowerCase()) >= 0)}
					<tr>
						<td>
							{#if get(marman.visible) && get(marman.loadState) === LoadState.LOADED}
								<a href='/' on:click|preventDefault={()=>{
									MapStore.helpers.zoomToFeature(marman.data);
								}}>{marman.name}</a>
							{:else}
								{marman.name}
							{/if}
						</td>
						<td>{marman.category}</td>
						<td>
							{#if get(marman.loadState) === LoadState.LOADING}
								Loading...
							{:else}
								<button
									class={(get(marman.visible)?"bg-primary":"bg-info")}
									style="font-size:12px;"
									on:click={()=>{
										marman.visible.set(!get(marman.visible));
										dispatch("update");
									}}
									>{get(marman.visible)}</button>
							{/if}
						</td>
					</tr>
				{/if}
			{/each}
		</tbody>
	</table>
</div>
